'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-neutral-50)]">
      <div className="max-w-md w-full mx-auto text-center space-y-6">
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-[var(--color-cta-danger)]">Something went wrong!</h2>
          <p className="text-[var(--color-neutral-600)]">
            An error occurred while loading this page.
          </p>
        </div>
        <div className="flex gap-4 justify-center">
          <Button
            onClick={reset}
            className="bg-[var(--color-brand-primary)] hover:bg-[var(--color-brand-primary-hover)]"
          >
            Try again
          </Button>
          <Button asChild variant="outline">
            <Link href="/">Go home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
} 